// ------------------------------------------------------------------------------
// name: useFormHelper
// author: mudas
// created: 2024-11-05
// ------------------------------------------------------------------------------

import { Form, FormInstance } from 'antd';
import { NamePath, Store, StoreValue } from 'rc-field-form/lib/interface';

type GetFieldWatch = <ValueType = StoreValue>(name: NamePath) => [ValueType, (value: ValueType) => void];
type FormInstanceResult<StateType = Store> = FormInstance<StateType> & { getFieldWatch: GetFieldWatch };

export const useFormHelper = <StateType = Store>(form?: FormInstance<StateType>) => {
  const context = Form.useFormInstance<StateType>();
  form = form || context;

  const __getFieldWatch = <ValueType = StoreValue>(name: NamePath) => {
    return [
      Form.useWatch(name, form),
      (value: ValueType) => {
        form.setFields && form.setFields([{ name, value }]);
      },
    ] as [ValueType, (value: ValueType) => void];
  };

  return {
    getFieldWatch: __getFieldWatch,
    ...form,
  } as FormInstanceResult<StateType>;
};
